
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(396|419|51|573)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
